import styled, { createGlobalStyle } from 'styled-components'
import { colors as oldColors } from 'shared/assets/styles'
import { colors } from 'app-v2/design-systems'
import { fonts } from 'app/common/typography'
import { BORDER, COLOR, TEXT, SPACING } from 'app-v2/design-tokens'

const { red, shadowBox, tertiary } = oldColors
const { roboto } = fonts

export const GlobalStyle = createGlobalStyle`
    .localities-container {
        flex-direction: column;
        margin-top: ${SPACING.S};
        margin-left: -60px;
        padding: 4px 25px;
        border-radius: 10px;
        border: none;
        font-size: ${props => props.textSize}px;
        box-sizing: border-box;
        ${props => props.size && `width: ${props.size}px !important;`};
        background: ${props => props.backgroundColor};
        ${({ forQuickSearch }) =>
            forQuickSearch &&
            `
                border-radius: 0;
                margin-top: 22px;
                box-shadow: none;
                margin-left: -82px;
                background: ${tertiary};
            `};
        z-index: 10000;
    }
    .localities-item {
        &:first-child {
            border: none;
        }
        color: ${COLOR.PRIMARY};
    }
    .localities-item-query {
        color: ${COLOR.PRIMARY};
    }
    .localities-item .localities-icon {
        background: ${COLOR.PRIMARY};
    }
    .localities-item-selected .localities-icon,
    .localities-item:hover .localities-icon {
        background: ${red};
    }
`

export const InputContainer = styled.div`
    display: flex;
    width: 100%;
    .localities-input-wrapper,
    .localities-input-container {
        width: 100%;
    }
    .localities-empty-button {
        background: transparent
            url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' fill='${encodeURIComponent(
                COLOR.PRIMARY
            )}'/%3E%3C/svg%3E")
            no-repeat 50% /20px 20px;
        display: flex;
        padding: 8px 16px;
    }
`

export const Input = styled.div`
    display: flex;
    align-items: center;
    min-height: 40px;
    border-radius: ${BORDER.RADIUS.M};
    box-sizing: border-box;
    padding: ${props => props.height}px 5px;
    ${props => props.shadow && `box-shadow: 0 4px 16px 4px ${shadowBox};`}
    border: ${props =>
        props.hasBorder ? `1px solid ${colors.lightGrey}` : 'none'};

    width: 100%;
    background: ${props => props.backgroundColor};
    ${({ forQuickSearch }) =>
        forQuickSearch &&
        `
            box-shadow: none;
            border-radius: 0;
            background: ${tertiary};
        `};

        ${({ forTPK }) =>
            forTPK &&
            `
            font-family: ${TEXT.FONT_FAMILY.DEFAULT_SANS};
            color: ${COLOR.PRIMARY};
            text-transform: none;
        `};

`

export const InputIcon = styled.div`
    display: flex;
    padding: 8px 16px;
    ${props => props.clickable && 'cursor: pointer'}
`

export const StyledInput = styled.input`
    color: ${COLOR.PRIMARY};
    display: flex;
    border: none;
    margin: 0;
    font-family: ${roboto};
    width: 100%;
    font-size: ${props => props.textSize}px;
    background: ${props => props.backgroundColor};
    padding: 0;
    ${({ forQuickSearch }) =>
        forQuickSearch &&
        `
            font-family: ${TEXT.FONT_FAMILY.DEFAULT};
            background: ${tertiary};
            color: ${COLOR.PRIMARY};
            font-size: 24px;
            min-height: 24px;
            margin: 20px;
        `};
`
